import React from "react";
import { Route, Switch } from "react-router-dom";
import LiveStatus from "./containers/campaign-live-status";

export default function LiveStatusRoutes({ match }) {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={LiveStatus} />
        </Switch>
    );
}
